module.exports = __webpack_public_path__ + "img/service_platformdev.6733304e.jpg";